import request from '@/utils/request'

const prefix = '/django_rest/microsoft-graph'

export default {
  checkMicrosoftGraphAuth () {
    return request.get(`${prefix}/check-auth/`)
  },
  createOnlineMeetingEvent (params) {
    return request.post(`${prefix}/online-meeting-event/`, params)
  },
  updateOnlineMeetingEvent (params) {
    return request.put(`${prefix}/online-meeting-event/`, params)
  },
  deleteOnlineMeetingEvent (eventId) {
    return request.delete(`${prefix}/online-meeting-event/${eventId}/`)
  }
}
